import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { finalize } from 'rxjs/operators';
import { AuthService } from '../../core/authentication/auth.service';
import { UserRegistration } from '../../shared/models/user.registration';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html'
})
export class RegisterComponent implements OnInit {

  UserForm = new FormGroup({});

  success: boolean;
  error: string;
  submitted: boolean = false;
  userObject: UserRegistration = { name: '', email: '', password: '' };
  constructor(private authService:AuthService,  private router: Router, private fb: FormBuilder)
   { }

  ngOnInit() {
    this.UserForm=this.fb.group({
      name: ['', Validators.required],
      email: ['', Validators.required],
      password: ['', Validators.required],
    });
  }


  onSubmit() { 
     ;
      this.userObject=this.UserForm.value 
       //console.log(this.userObject)
      this.authService.register(this.userObject)
     .subscribe(
       result=>{
         if(result)
         {
           this.success=true
           this.router.navigate(['/account/login']);    

         }
       },
       error=>{
        this.error = error;   
       }
     )
       
  
      }

}
